import { createRoiScheme, readRoiScheme, droiScheme } from './roiSchemeHandler';
import { TIME_FILTER_TYPE_OPTIONS } from '../../../constants';
import { get, CleanSchema } from '../../../json-transform';
import { EVENT_POLICY_TRIGGER_OPTIONS, IMAGE_FORMAT_OPTIONS, SENDING_TYPE_OPTIONS } from '../../constants';

export const createFallAnalytic = new CleanSchema({
  analytic_name: get('analytic_name'),
  parameters: {
    parameters: {
      fall_threshold: get('parameters.parameters.fall_threshold').asFloat().ifNaN(undefined),
      time_filter: {
        type: get('parameters.parameters.time_filter.type').asOptionValue(),
        length: get('parameters.parameters.time_filter.length').asInt().ifNaN(undefined),
      },
      event_policy: {
        trigger: get('parameters.parameters.event_policy.trigger').asOptionValue(),
        interval: get('parameters.parameters.event_policy.interval').asFloat().ifNaN(undefined),
      },
      image_retain_policy: {
        mimetype: get('parameters.parameters.image_retain_policy.mimetype').asOptionValue(),
        quality: get('parameters.parameters.image_retain_policy.quality').asFloat().ifNaN(undefined),
        max_size: get('parameters.parameters.image_retain_policy.max_size').asInt().ifNaN(undefined),
      },
      rate: {
        unit: get('parameters.parameters.rate.unit').asOptionValue(),
        period: get('parameters.parameters.rate.period').asFloat().ifNaN(undefined),
      },
      roi: get('parameters.parameters.roi').as(createRoiScheme),
      droi: get('parameters.parameters.droi').as(droiScheme),
    },
    targets: get('parameters.targets'),
    callbacks: get('parameters.callbacks').asArrayOf(),
  },
});

export const readFallAnalytic = new CleanSchema({
  analytic_name: get('analytic_name'),
  parameters: {
    parameters: {
      fall_threshold: get('parameters.parameters.fall_threshold'),
      time_filter: {
        type: get('parameters.parameters.time_filter.type').asOption(TIME_FILTER_TYPE_OPTIONS),
        length: get('parameters.parameters.time_filter.length'),
      },
      event_policy: {
        trigger: get('parameters.parameters.event_policy.trigger').asOption(EVENT_POLICY_TRIGGER_OPTIONS),
        interval: get('parameters.parameters.event_policy.interval'),
      },
      image_retain_policy: {
        mimetype: get('parameters.parameters.image_retain_policy.mimetype').asOption(IMAGE_FORMAT_OPTIONS),
        quality: get('parameters.parameters.image_retain_policy.quality'),
        max_size: get('parameters.parameters.image_retain_policy.max_size'),
      },
      rate: {
        unit: get('parameters.parameters.rate.unit').asOption(SENDING_TYPE_OPTIONS),
        period: get('parameters.parameters.rate.period'),
      },
      roi: get('parameters.parameters.roi').as(readRoiScheme),
      droi: get('parameters.parameters.droi').as(droiScheme),
    },
    targets: get('parameters.targets'),
    callbacks: get('parameters.callbacks').asArrayOf(),
  },
  status: get('status'),
  autorestart: get('autorestart'),
});
